'use strict';

var isEnabled = function isEnabled() {
  return (window.IntercomIncludeInDevelopment || process.env.NODE_ENV === 'production') && typeof Intercom === 'function' && window.IntercomAppId;
};

exports.onInitialClientRender = function () {
  if (!isEnabled()) {
    return;
  }

  window.Intercom('boot', {
    app_id: window.IntercomAppId
  });
};

exports.onRouteUpdate = function (_ref) {
  var location = _ref.location;

  if (!isEnabled()) {
    return;
  }

  window.Intercom('update');
};